import { AppBar, Avatar, Box, Menu, MenuItem, Typography } from "@mui/material";
// import moment from "moment";
import React from "react";
import Logo from "../../Assets/images/logo1024.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./Nav.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab, setLocationId } from "../../Redux/reportSlice";
import {
  dispatchRefreshApiCallLocation,
  dispatchRefreshApiCallPermission,
  dispatchRefreshApiCallUser,
  dispatchRefreshApiCallVendor,
} from "../../Redux/dispatcher";
import { setUserType, setUserTypeData } from "../../Redux/persistApiDataSlice";

const Nav = ({ IsAuthenticated, setIsAuthenticated }) => {
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsAuthenticated(null);
    localStorage.removeItem("accessToken");
    navigate("/cms/login");
    dispatcher(setLocationId(1));
    dispatcher(setActiveTab("1"));
    dispatcher(setUserType(null));
    dispatcher(setUserTypeData([]));
    dispatcher(dispatchRefreshApiCallUser(true));
    dispatcher(dispatchRefreshApiCallVendor(true));
    dispatcher(dispatchRefreshApiCallLocation(true));
    dispatcher(dispatchRefreshApiCallPermission(true));
  };

  return (
    <>
      <AppBar position="sticky" sx={{ background: "#FFFFFF", color: "black" }}>
        <Box sx={{ padding: "1rem" }}>
          <Box className="Nav-first-row">
            {/* <Typography variant="p">Welcome back!</Typography>
            <Typography variant="p">{moment().format("ll")}</Typography> */}
            <Box component="img" src={Logo} alt="Logo" sx={{ width: "60px" }} />
            <Box
              // variant="h6"
              className="nav-user-name"
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              tabIndex={0}
              onClick={handleClick}
            >
              <Avatar />
              <Box>
                <Typography
                  className="username"
                  variant="h6"
                >{`${IsAuthenticated.firstName} ${IsAuthenticated.lastName}`}</Typography>
                <Typography variant="body2">Admin</Typography>
              </Box>
              <KeyboardArrowDownIcon />
            </Box>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={Boolean(open)}
              onClose={handleMenuClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
                role: "menu",
              }}
              PaperProps={{
                style: {
                  width: anchorEl ? anchorEl.offsetWidth : undefined,
                },
              }}
            >
              <MenuItem onClick={handleClose}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </AppBar>
    </>
  );
};

export default Nav;
